import React, { useState } from 'react'
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField, Typography, Button, CircularProgress } from '@material-ui/core'
import Rating from '@material-ui/lab/Rating'
import { Timestamp } from '@firebase/firestore';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

const WriteReviewModal = ({ place, open, setModalOpen, submitReview, finishedAddingReview, setIsLoading }) => {

    const [rating, setRating] = useState(0)
    const [name, setName] = useState('')
    const [description, setDescription] = useState('')

    const [errorOpen, setErrorOpen] = useState(false)

    function handleClose() {
        setModalOpen(false)
    }

    function handleErrorClose() {
        setErrorOpen(false)
    }

    function checkReviewInput() {
        if(rating == 0) {
            setErrorOpen(true)
            return
        }
        
        const reviewData = {
            'rating': rating,
            'timestamp': Timestamp.now(),
        }

        if(!stringEmpty(name)) {
            reviewData.name = name
        }

        if(!stringEmpty(description)) {
            reviewData.description = description
        }

        // Calculate new location rating
        var newRating = rating
        if(place?.reviews) {
            var overallRating = rating
            place.reviews.forEach(rev => {
                overallRating += rev.rating
            });

            newRating = overallRating / (place.reviews.length + 1)
        }
        console.log('newRating = ' + newRating)

        setIsLoading(true)
        submitReview(place.docId, reviewData, newRating, finishedAddingReview, setIsLoading)
    }

    function stringEmpty(str) {
        return (!str || str.length === 0 );
    }
    

    const handleInputName = (event) => {
        setName(event.target.value);
    }

    const handleInputDescription = (event) => {
        setDescription(event.target.value);
    }

    return (
        <div>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Write a Review</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Leave some feedback for {place.name}
                    </DialogContentText>
                    <Typography component="legend">Rate your Experience</Typography>
                    <Rating name="simple-controlled" value={rating} onChange={(event, newValue) => {
                        setRating(newValue)
                    }} />
                    <TextField
                        autoFocus
                        margin="dense"
                        id="name"
                        label="Your name (optional)"
                        fullWidth
                        variant="outlined"
                        onChange={handleInputName}
                        value={name}
                    />
                    <TextField
                        margin="dense"
                        id="description"
                        label="What did you think?"
                        fullWidth
                        variant="outlined"
                        onChange={handleInputDescription}
                        value={description}
                        multiline
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={checkReviewInput}>Submit Review</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={errorOpen} onClose={handleErrorClose}>
                <DialogTitle>Error</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        You must include a star rating!
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleErrorClose}>Ok</Button>
                </DialogActions>
            </Dialog>
        </div>
        
    )
}

export default WriteReviewModal